<template>
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="card mb-4">
            <div class="card-body">
                <div class="row">
                    <BillingListTableComponent :transactions="transactions" />
                </div>
            </div>
        
        </div>
    </div>
    
</template>

<script>
    import axios from 'axios';
    import BillingListTableComponent from '../components/BillingListTable.vue';
    export default {
        components: { BillingListTableComponent },
        data() {
            return {
                transactions: [],
                loading: true,
                error: null,
                pollingInterval: null
                
            };
        },
        created() {
            this.fetchTransactionData();
        },
        mounted() {
            // Start polling every 10 seconds
            this.pollingInterval = setInterval(() => {
                this.fetchTransactionData();
            }, 10000);
        },
        beforeUnmount() {
            // Clear polling when component is destroyed
            clearInterval(this.pollingInterval);
        },
        methods: {
            fetchTransactionData() {
                const customerId = localStorage.getItem('customerId');
                if(customerId != undefined){
                    axios.get('/api/zoho/customer-transactions/' + customerId)
                    .then(response => {
                        let data = response.data;
                        this.transactions = data.transactions;
                    })
                    .catch(() => {
                        this.error = 'Failed to fetch billing.';
                    })
                    .finally(() => {
                        this.loading = false;
                    });
                }
                
            }

        },
    };
</script>

<style scoped>
/* Add dashboard styles here */
</style>
